import type { MessageKey } from 'types/LocaleMessageKey';

interface StatLine {
  id: number;
  figure: MessageKey;
  caption: MessageKey;
}

export const STAT_LINES: StatLine[] = [
  {
    id: 0,
    figure: 'about_us_stat_figure_1',
    caption: 'about_us_stat_caption_1',
  },
  {
    id: 1,
    figure: 'about_us_stat_figure_2',
    caption: 'about_us_stat_caption_2',
  },
  {
    id: 2,
    figure: 'about_us_stat_figure_3',
    caption: 'about_us_stat_caption_3',
  },
  {
    id: 3,
    figure: 'about_us_stat_figure_4',
    caption: 'about_us_stat_caption_4',
  },
];
